module.exports = __webpack_public_path__ + "media/images/ohap_invite people_off-b5808a47aa25cb07f7cb8fee7baf9145.png";